module.exports = __webpack_public_path__ + "img/telecoms_icon.62566713.png";